module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_9.0cd4fe3e.png";